export default __webpack_public_path__ + "static/media/feroze-khan.0e13b91a.jpg";